/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentUploadRequestedEventTimelinePayload
 */
export interface DocumentUploadRequestedEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof DocumentUploadRequestedEventTimelinePayload
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentUploadRequestedEventTimelinePayload
     */
    documentType: string;
}

/**
 * Check if a given object implements the DocumentUploadRequestedEventTimelinePayload interface.
 */
export function instanceOfDocumentUploadRequestedEventTimelinePayload(value: object): value is DocumentUploadRequestedEventTimelinePayload {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    return true;
}

export function DocumentUploadRequestedEventTimelinePayloadFromJSON(json: any): DocumentUploadRequestedEventTimelinePayload {
    return DocumentUploadRequestedEventTimelinePayloadFromJSONTyped(json, false);
}

export function DocumentUploadRequestedEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentUploadRequestedEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'documentId': json['documentId'],
        'documentType': json['documentType'],
    };
}

export function DocumentUploadRequestedEventTimelinePayloadToJSON(value?: DocumentUploadRequestedEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'documentId': value['documentId'],
        'documentType': value['documentType'],
    };
}

